export default __webpack_public_path__ + "static/Entenda0138-eb724d83afd4a6e1728d827c599b5174.jpg";